/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import wizardStyle from "@/src/components/Form/wizardStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import Distance5Icon from "@/src/assets/icons/traffic/toggleable/IconDistanceFiveToTen";
import Distance4Icon from "@/src/assets/icons/traffic/toggleable/IconDistanceFourToTen";
import Distance3Icon from "@/src/assets/icons/traffic/toggleable/IconDistanceThreeToTen";
import Distance2Icon from "@/src/assets/icons/traffic/toggleable/IconDistanceTwoToTen";
import Distance1Icon from "@/src/assets/icons/traffic/toggleable/IconDistance";
import QuestionIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "@/src/services/translations/translations";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import { Box } from "@mui/material";

export default function Distance({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="distance"
                question={translate("traffic.distance.label", values)}
                modalContent="Bitte prüfen Sie den Bescheid. Dort ist der Verstoß in Zehnteln des halben Tachowertes angegeben."
                options={[
                  {
                    labelText: translate("traffic.distance.options.5/10.label", values),
                    labelIcon: <Distance5Icon />,
                    labelIconActive: <Distance5Icon active />,
                    value: "5/10",
                  },
                  {
                    labelText: translate("traffic.distance.options.4/10.label", values),
                    labelIcon: <Distance4Icon />,
                    labelIconActive: <Distance4Icon active />,
                    value: "4/10",
                  },
                  {
                    labelText: translate("traffic.distance.options.3/10.label", values),
                    labelIcon: <Distance3Icon />,
                    labelIconActive: <Distance3Icon active />,
                    value: "3/10",
                  },
                  {
                    labelText: translate("traffic.distance.options.2/10.label", values),
                    labelIcon: <Distance2Icon />,
                    labelIconActive: <Distance2Icon active />,
                    value: "2/10",
                  },
                  {
                    labelText: translate("traffic.distance.options.1/10.label", values),
                    labelIcon: <Distance1Icon />,
                    labelIconActive: <Distance1Icon active />,
                    value: "1/10",
                  },
                  {
                    labelText: translate("traffic.distance.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
